import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import { PropType } from 'vue';
import MyButtonBase from './MyButtonBase.vue';
import { IonIcon, IonBadge, IonSpinner } from '@ionic/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MyButton',
  props: {
  label: { type: String, required: true },
  icon: String,
  iconSlot: { type: String as PropType<'start' | 'end'>, default: 'start' },
  badgeText: String,
  badgeSlot: { type: String as PropType<'start' | 'end'>, default: 'end' },
  badgeColor: { type: String, default: 'primary' },
  showSpinner: { type: Boolean, default: false },
  spinnerSlot: { type: String as PropType<'start' | 'end'>, default: 'start' },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MyButtonBase, null, {
    default: _withCtx(() => [
      (__props.showSpinner)
        ? (_openBlock(), _createBlock(_unref(IonSpinner), {
            key: 0,
            slot: __props.spinnerSlot,
            class: "ion-margin-horizontal"
          }, null, 8, ["slot"]))
        : _createCommentVNode("", true),
      (__props.icon)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 1,
            class: "icon-class",
            slot: __props.iconSlot,
            icon: __props.icon
          }, null, 8, ["slot", "icon"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({ labelIconClass: __props.icon, labelOnlyClass: !__props.icon })
      }, _toDisplayString(__props.label), 3),
      (__props.badgeText)
        ? (_openBlock(), _createBlock(_unref(IonBadge), {
            key: 2,
            slot: __props.badgeSlot,
            color: __props.badgeColor
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.badgeText), 1)
            ]),
            _: 1
          }, 8, ["slot", "color"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})